<template>
  <div>
    <iframe :src="url" class="view" />
  </div>
</template>

<script>
import user from '../../api/user'

export default {
  data() {
    return {
      url: '',
    }
  },
  methods: {
    getBiToken() {
      user.getBiToken().then((res) => {
        console.log(res)
        if (res.code == 0) {
          console.log('process.env.NODE_ENV',process.env.NODE_ENV)
          let hostUrl = ''
          if (process.env.NODE_ENV == 'development')
            hostUrl = '192.168.150.1:5500'
          else
            hostUrl = process.env.VUE_APP_BIHOSTURL
              ? process.env.VUE_APP_BIHOSTURL
              : 'bi.khsdb.com'

          const url = `https://${hostUrl}/#/manage/center/overviewTerm/dailyOperations?system=school&token=${res.token}`
          this.url = url
        }
      })
    },
  },
  created() {
    this.getBiToken()
  },
}
</script>

<style lang="less" scoped>
// @import "src/config/var";
.view {
  width: calc(100% - 120px);
  height: calc(100% - 64px);
  position: absolute;
  right: 0;
  // left: 0;
  bottom: 0;
}
</style>
